export default __webpack_public_path__ + "static/media/shef-closure.615482da.png";